module.exports = __webpack_public_path__ + "img/121.272e22f8.png";